import styles from "./index.module.less";
import { useUser } from "@/utils/UserContext";
import { InputField } from "@wk/components-react16";
import { ButtonField } from "@wk/components-react16";
import { useState, useMemo, useRef, useEffect } from "react";
import { getPlayerDetail, getCode, verifySmsCode } from "@/services/user";
import { useNavigate } from "react-router-dom";
import { Iconsvg } from "@wk/components-react16";
import ModalConfirm from "../../components/modal";
import config from "@/config/env";

const phoneRegex = /^1[3-9]\d{9}$/;
const Login = () => {
  const navigate = useNavigate();
  const { set } = useUser();
  const [phoneValue, setPhoneValue] = useState("");
  const [inputStatus, setInputStatus] = useState("none");
  const [userInfo, setUserInfo] = useState(null);
  const [second, setSecond] = useState(0);
  const [isNextLoading, setIsNextLoading] = useState(false);
  const [isGetCode, setIsGetCode] = useState(false);
  const [isModal, setIsModal] = useState(false);

  const [firstCode, setFirstCode] = useState("");
  const [secondCode, setSecondCode] = useState("");
  const [thirdCode, setThirdCode] = useState("");
  const [forthCode, setForthCode] = useState("");
  const codeNumFirstRef = useRef(null);
  const codeNumSecondRef = useRef(null);
  const codeNumThirdRef = useRef(null);
  const codeNumForthRef = useRef(null);

  const [isVerifyLoading, setIsVerifyLoading] = useState(false);
  const [isVerifyError, setIsVerifyError] = useState(false);
  const [isMessageOpen, setIsMessageOpen] = useState(false);
  const [messageText, setMessageText] = useState("");

  const errorText = useMemo(() => {
    if (inputStatus === "none") {
      return [];
    }
    if (!phoneValue) {
      return [{ label: "请输入手机号", labelId: "1" }];
    }

    const phoneRegex = /^1[3-9]\d{9}$/;
    if (!phoneRegex.test(phoneValue)) {
      return [{ label: "请输入正确的手机号", labelId: "2" }];
    }
  }, [inputStatus, phoneValue]);

  const delText = useMemo(() => {
    return `我们已向电话+XXXXXXXXXXX${phoneValue.slice(
      phoneValue.length - 2
    )}发送短信。请输入验证码以登录。`;
  }, [phoneValue]);

  const verifyCode = async (
    valueFirst,
    valueSecond,
    valueThird,
    valueForth
  ) => {
    if (!valueFirst || !valueSecond || !valueThird || !valueForth) {
      return;
    }

    setIsVerifyLoading(true);
    const res = await verifySmsCode(
      `${valueFirst}${valueSecond}${valueThird}${valueForth}`,
      phoneValue
    );
    if (res.code === 200) {
      set(userInfo);
      // 跳转到选手主页
      navigate("/player/personalCases");
    }

    if (res?.code === 500) {
      setIsVerifyError(true);
    }

    setIsVerifyLoading(false);
  };

  const next = async () => {
    if (!phoneValue || !phoneRegex.test(phoneValue)) {
      setInputStatus("error");
      return;
    }

    setIsNextLoading(true);
    const resUser = await getPlayerDetail(phoneValue);
    if (resUser.code === 200) {
      if (
        !resUser?.result?.current ||
        !(resUser?.result?.current?.status === "1")
      ) {
        setIsModal(true);
      } else {
        setUserInfo(resUser?.result?.current);
        const resCode = await getCode(phoneValue);
        // 开始倒计时
        let time = 60;
        setSecond(--time);
        let clearTimer = setInterval(() => {
          setSecond(--time);
          if (time < 1) {
            clearInterval(clearTimer);
          }
        }, 1000);

        if (resCode.code === 200) {
          setIsGetCode(true);
          setTimeout(() => {
            codeNumFirstRef.current.focus();
          }, 1000);
        } else if (resCode?.code === 500) {
          setMessageText("短信验证码发送失败，请稍后重试");
          setIsMessageOpen(true);
        }
      }
    }

    setIsNextLoading(false);
  };

  const getCodeByPhone = async () => {
    const resCode = await getCode(phoneValue);
    // 开始倒计时
    let time = 60;
    setSecond(--time);
    let clearTimer = setInterval(() => {
      setSecond(--time);
      if (time < 1) {
        clearInterval(clearTimer);
      }
    }, 1000);
    if (resCode?.code === 500) {
      setMessageText("短信验证码发送失败，请稍后重试");
      setIsMessageOpen(true);
    }
  };

  useEffect(() => {
    verifyCode(firstCode, secondCode, thirdCode, forthCode);
  }, [firstCode, secondCode, thirdCode, forthCode]);

  return (
    <div className={styles["login-view"]}>
      <div className="login-container">
        {isGetCode ? (
          <>
            <div className="login-title code-title">输入验证码</div>

            <div className="modal-del">
              <Iconsvg name="chat-box" size={20} color="#353535" />
              {delText}
            </div>

            <div className="modal-input">
              <div className="first-code-number">
                <InputField isDisabled={isVerifyLoading}>
                  <input
                    ref={codeNumFirstRef}
                    type="text"
                    value={firstCode}
                    onChange={(e) => {
                      setFirstCode(e.target.value);
                      setIsVerifyError(false);
                      if (e.target.value) {
                        codeNumSecondRef.current.focus();
                      }
                    }}
                    onInput={(e) => {
                      if (e.target.value) {
                        codeNumSecondRef.current.focus();
                      }
                    }}
                    maxLength="1"
                    readOnly={isVerifyLoading}
                  />
                </InputField>
              </div>
              <div className="second-code-number">
                <InputField isDisabled={isVerifyLoading}>
                  <input
                    ref={codeNumSecondRef}
                    type="text"
                    value={secondCode}
                    onChange={(e) => {
                      setSecondCode(e.target.value);
                      setIsVerifyError(false);
                      if (e.target.value) {
                        codeNumThirdRef.current.focus();
                      } else {
                        codeNumFirstRef.current.focus();
                      }
                    }}
                    onInput={(e) => {
                      if (e.target.value) {
                        codeNumThirdRef.current.focus();
                      } else {
                        codeNumFirstRef.current.focus();
                      }
                    }}
                    maxLength="1"
                    readOnly={isVerifyLoading}
                  />
                </InputField>
              </div>
              <div className="third-code-number">
                <InputField isDisabled={isVerifyLoading}>
                  <input
                    ref={codeNumThirdRef}
                    type="text"
                    value={thirdCode}
                    onChange={(e) => {
                      setThirdCode(e.target.value);
                      setIsVerifyError(false);
                      if (e.target.value) {
                        codeNumForthRef.current.focus();
                      } else {
                        codeNumSecondRef.current.focus();
                      }
                    }}
                    onInput={(e) => {
                      if (e.target.value) {
                        codeNumForthRef.current.focus();
                      } else {
                        codeNumSecondRef.current.focus();
                      }
                    }}
                    maxLength="1"
                    readOnly={isVerifyLoading}
                  />
                </InputField>
              </div>
              <div className="fourth-code-number">
                <InputField isDisabled={isVerifyLoading}>
                  <input
                    ref={codeNumForthRef}
                    type="text"
                    value={forthCode}
                    onChange={(e) => {
                      setForthCode(e.target.value);
                      setIsVerifyError(false);
                      if (!e.target.value) {
                        codeNumThirdRef.current.focus();
                      }
                    }}
                    onInput={(e) => {
                      if (!e.target.value) {
                        codeNumThirdRef.current.focus();
                      }
                    }}
                    maxLength="1"
                    readOnly={isVerifyLoading}
                  />
                </InputField>
              </div>
            </div>

            {isVerifyError && <div className="cg-field-error">验证码错误</div>}

            <div className="modal-button">
              <ButtonField mode={"text"}>
                <button
                  type="button"
                  onClick={() => getCodeByPhone()}
                  disabled={isNextLoading || !(second < 1)}
                >
                  {second < 1
                    ? "重新获取验证码"
                    : `${second}秒后可重新获取短信`}
                  {isNextLoading && (
                    <Iconsvg name="spinner-alt" isSpin></Iconsvg>
                  )}
                </button>
              </ButtonField>
            </div>
          </>
        ) : (
          <>
            <div className="login-title">登录</div>
            <InputField label="手机号" status={inputStatus} errors={errorText}>
              <input
                type="text"
                placeholder="请输入手机号"
                value={phoneValue}
                onChange={(e) => {
                  setPhoneValue(e.target.value);
                  if (!e.target.value) {
                    setInputStatus("error");
                    return;
                  }

                  if (!phoneRegex.test(e.target.value)) {
                    setInputStatus("error");
                    return;
                  }

                  setInputStatus("none");
                }}
                maxLength="11"
              />
            </InputField>
            <div className="modal-button">
              <ButtonField>
                <button
                  type="button"
                  onClick={() => next()}
                  disabled={isNextLoading || !(second < 1)}
                >
                  {second < 1 ? "验证手机号码" : `${second}秒后可重新获取短信`}
                  {isNextLoading && (
                    <Iconsvg name="spinner-alt" isSpin></Iconsvg>
                  )}
                </button>
              </ButtonField>
            </div>
          </>
        )}
      </div>

      <ModalConfirm
        isOpen={isModal}
        onClose={() => {
          setIsModal(false);
        }}
        children={
          <div className="modal-body-text">
            您的账号未注册,需要注册后才能登录
          </div>
        }
        title="提示"
        onConfirm={() => {
          setIsModal(false);
          window.open(`${config.pdfBaseUrl}/register`);
        }}
        okText="去注册"
      />

      <ModalConfirm
        isOpen={isMessageOpen}
        onClose={() => {
          setIsMessageOpen(false);
          setMessageText("");
        }}
        children={<div className="modal-body-text">{messageText}</div>}
        title={"操作确认"}
        onConfirm={() => {
          setIsMessageOpen(false);
          setMessageText("");
        }}
        okText="确认"
      />
    </div>
  );
};
export default Login;
